/**
 * Утилиты для модальных окон.
 */
export class ModalUtils {
  /**
   * Убирает состояние preload у модальных окон.
   */
  public static clearPreload(): void {
    const modalElements = document.querySelectorAll('.modal')
    if (modalElements.length) {
      modalElements.forEach((el) => {
        setTimeout(() => {
          el.classList.remove('modal--preload')
        }, 100)
      })
    }
  }
}
